import _differenceWith from 'lodash-es/differenceWith';
import _isEqual from 'lodash-es/isEqual';
import { getFormattedEndDate } from '../../../../helpers';
import { minStartDate, minEndDate } from '../../common/helpers/inputHandlers';
import {
  programStartDateError,
  programEndDateError,
} from '../../../WalletPrograms/constants';

export const getGroupsData = (groups, programInfo) => {
  const formattedGroups = [];
  groups.forEach(group => {
    if (group?.can_plan_be_mapped && group?.active_employees > 0)
      formattedGroups.push({
        label: `${group?.group_name} (${group?.active_employees} employees)`,
        value: group?.group_id,
      });
  });

  const planDataSGroups = programInfo?.groups_data?.map(group => ({
    label: `${group?.group_name} (${group?.active_employees} employees)`,
    value: group?.group_id,
  }));

  const planDataUGroups = _differenceWith(
    formattedGroups,
    planDataSGroups,
    _isEqual,
  );

  return {
    allGroups: formattedGroups,
    selectedGroups: planDataSGroups ?? [],
    unSelectedGroups: planDataUGroups ?? [],
  };
};

export const createInitialFormData = (
  programId,
  selectedGroups,
  unSelectedGroups,
  selectedWorkspace,
  currentFlow,
) => ({
  programId,
  selectedGroups: [...selectedGroups],
  unSelectedGroups: [...unSelectedGroups],
  showError: false,
  name: '',
  nameErrMsg: '',
  type: 1,
  workspaceID: selectedWorkspace?.workspace_id,
  startDate: minStartDate,
  startTime: '00:00',
  endDate: minEndDate,
  neverEnd: true,
  flowType: currentFlow,
});

export const createFormDataFromProgramInfo = (
  programInfo,
  programId,
  selectedGroups,
  unSelectedGroups,
  selectedWorkspace,
  currentFlow,
) => ({
  programId: programInfo?.program_id ?? programId,
  selectedGroups: [...selectedGroups],
  unSelectedGroups: [...unSelectedGroups],
  showError: false,
  name: programInfo?.name ?? '',
  nameErrMsg: '',
  type: 1,
  workspaceID: selectedWorkspace?.workspace_id,
  startDate: programInfo?.start_date ?? minStartDate,
  startTime: programInfo?.start_time ?? '00:00',
  endDate: getFormattedEndDate(programInfo?.end_date),
  neverEnd: programInfo?.never_ends ?? true,
  flowType: currentFlow,
});

export const isFormValid = formData => {
  const isNameValid = !!formData?.name && formData?.name?.trim()?.length > 0;
  const isGroupsValid =
    !!formData?.selectedGroups && formData?.selectedGroups?.length > 0;
  const isStartDateValid =
    !!formData?.startDate && !Number.isNaN(Date.parse(formData.startDate));
  const isStartTimeValid =
    !!formData?.startTime && formData?.startTime?.trim()?.length > 0;
  let isEndDateTimeValid = true;
  if (!formData?.neverEnd) {
    isEndDateTimeValid =
      !!formData?.endDate &&
      !Number.isNaN(Date.parse(formData.endDate)) &&
      Date.parse(formData.endDate) >= Date.parse(formData.startDate);
  }

  return (
    isNameValid &&
    isGroupsValid &&
    isStartDateValid &&
    isStartTimeValid &&
    isEndDateTimeValid
  );
};

export const validateDates = (formData, showErrorToast) => {
  if (Date.parse(`${formData?.startDate}`) < Date.parse(`${minStartDate}`)) {
    showErrorToast(programStartDateError);
    return false;
  }
  if (
    !formData?.neverEnd &&
    Date.parse(`${formData?.endDate}`) < Date.parse(`${formData?.startDate}`)
  ) {
    showErrorToast(programEndDateError);
    return false;
  }
  return true;
};

export const createProgramBody = (
  formData,
  programInfo,
  programId,
  selectedWorkspace,
  currentFlow,
) => ({
  programId: programInfo?.program_id ?? programId,
  name: formData?.name,
  selectedGroups: formData?.selectedGroups?.map(group => group?.value),
  type: formData?.type,
  workspaceID: selectedWorkspace?.workspace_id,
  startDate: formData?.startDate,
  startTime: formData?.startTime,
  endDate: formData?.endDate,
  neverEnd: formData?.neverEnd,
  flowType: currentFlow,
  restrictionsType: formData?.restrictionsType ?? 2,
});
